<template>
<svg viewBox="0 0 48 48" :fill="useCurrentColor ? 'currentColor' : 'currentColor'" :class="[`${prefix}-icon`, `${prefix}-icon-comment`]" width="1em" height="1em" v-bind="$attrs"><path fill-rule="evenodd" clip-rule="evenodd" d="M42 3a2 2 0 012 2v32a2 2 0 01-2 2H31.777l-6.44 5.796a2 2 0 01-2.675 0L16.222 39H6a2 2 0 01-2-2V5a2 2 0 012-2h36zm-2 4H8v28h9.757L24 40.618 30.242 35H40V7zm-6 13a1 1 0 00-1-1H15a1 1 0 00-1 1v2a1 1 0 001 1h18a1 1 0 001-1v-2z"/></svg>
</template>
<script>

export default {
  name: 'IconComment',
  props: {
    prefix: {
        type: String,
        default: 'm',
    },
    useCurrentColor: {
        type: Boolean,
        default: false,
    },
  },
};
</script>
